import { useUnit } from 'effector-react'

import {
  $crowns,
  $errorCrownsRequest,
  $totalCountOfCrowns,
  crownsListMounted,
  getCrowns,
} from './model'
import { CrownRequest } from './types'

export const useCrownsList = (clientId: string) => {
  const onChangeCrownsList = ({
    clientId,
    limit,
    page,
    order,
    filters,
  }: CrownRequest) => {
    crownsListMounted({
      clientId,
      limit,
      page,
      order,
      filters,
    })
  }

  const loading = useUnit(getCrowns.pending)

  const crowns = useUnit($crowns)
  const totalCountOfCrowns = useUnit($totalCountOfCrowns)
  const errorCrownsRequest = useUnit($errorCrownsRequest)

  return {
    crowns,
    totalCountOfCrowns,
    loading,
    onChangeCrownsList,
    errorCrownsRequest,
  }
}
